import { getStudentSchoolID } from "state/school_money/selectors";

/**
 * @returns {Immutable.Map}
 */
export function getSchoolByID(state, schoolID) {
  return state.getIn(["school_money", "schools", schoolID]);
}

/**
 * @returns {Immutable.Map}
 */
export function getSchoolByStudentID(state, studentID) {
  return getSchoolByID(state, getStudentSchoolID(state, studentID));
}

/**
 * Get the payment provider that we will use (ps - paysafe | st - secure trading)
 * @returns {char(2)}
 */
export function paymentProvider(state, schoolID) {
  return getSchoolByID(state, schoolID).paymentProvider;
}

/**
 * @returns {boolean}
 */
export function isDinnersEnabled(state, schoolID) {
  return getSchoolByID(state, schoolID).isDinnersEnabled;
}

/**
 * @returns {boolean}
 */
export function isClubTopUpsEnabled(state, schoolID) {
  return getSchoolByID(state, schoolID).isClubTopUpsEnabled;
}

/**
 * @returns {money}
 */
export function getClubTopUpDefaultAmount(state, schoolID) {
  return getSchoolByID(state, schoolID).defaultClubTopUpAmount;
}

/**
 * @returns {boolean}
 */
export function isDinnerTopUpsEnabled(state, schoolID) {
  return getSchoolByID(state, schoolID).isDinnerTopUpsEnabled;
}

/**
 * @returns {money}
 */
export function getDinnerTopUpDefaultAmount(state, schoolID) {
  return getSchoolByID(state, schoolID).get("defaultDinnerTopUpAmount");
}

/**
 * @returns {Immutable.List}
 */
export function getSchoolIDList(state) {
  return state.getIn(["school_money", "schools"]).keySeq().toList();
}

/**
 * @returns {Immutable.List}
 */
export function getSchoolList(state) {
  return state.getIn(["school_money", "schools"])
    .sortBy(school => school.get("name"))
    .toList();
}

/**
 * @returns {boolean}
 */
export function isSchoolsReady(state) {
  return !state.getIn(["school_money", "isSchoolsLoading"]);
}

/**
 * Get the key by which we should sort schools.
 * @returns {string}
 */
export function getSchoolSortByKey(state, schoolID) {
  const school = getSchoolByID(state, schoolID);
  if (school) {
    return school.name;
  }
}

/**
 * @returns {string}
 */
export function getExternalCashlessName(state, schoolID) {
  return getSchoolByID(state, schoolID).get("externalCashlessName");
}

/**
 * @returns {boolean}
 */
export function isXodActive(state, schoolID) {
  return getSchoolByID(state, schoolID).get("isXodActive");
}

/**
 * @returns {boolean}
 */
export function isExternalTopUpEnabled(state, schoolID) {
  return getSchoolByID(state, schoolID).get("isExternalTopUpEnabled");
}

/**
 * @returns {money}
 */
export function getMinimumPaymentAmount(state, schoolID) {
  return getSchoolByID(state, schoolID).get("minimumPaymentAmount");
}

/**
 * @returns {boolean}
 */
export function isApplePayEnabledForSchool(state, schoolID) {
  return getSchoolByID(state, schoolID).get("isApplePayEnabled");
}

/**
 * @returns {boolean}
 */
export function isGooglePayEnabledForSchool(state, schoolID) {
  return getSchoolByID(state, schoolID).get("isGooglePayEnabled");
}



// WEBPACK FOOTER //
// ./src/state/school_money/selectors/schools.js